export default __webpack_public_path__ + "locales/vi/FilesSettings.json?hash=c6bd7cd4eb206c798dd1f72a9b28c236";